import React, { useState } from 'react';
import flower from '../images/flower.png';
import ContactModal from '../components/ContactModal';
import { GROOM_FAMILY, BRIDE_FAMILY, INVITATION } from '../constants/wedding';

function Invitation() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  function FamilyInfo({ dad, mom, child, relation }) {
    return (
      <div className='invitation__family'>
        <div className='invitaion__parent'>
          <div>{dad}·{mom}</div>
        </div>
        <div>{relation}</div>
        <div className='invitation__child'>{child}</div>
      </div>
    );
  }

  return (
    <div className='bc-alt container'>
      <img src={flower} className='flower' alt='flower'/>
      <div className='invitation__title'>{INVITATION.title}</div>
      <div className='invitation__content'>
        {INVITATION.paragraphs.map((paragraph) => (
          <div key={paragraph}>{paragraph}</div>
        ))}
      </div>
      <FamilyInfo
        dad={GROOM_FAMILY.father.name}
        mom={GROOM_FAMILY.mother.name}
        child={GROOM_FAMILY.groom.name}
        relation={GROOM_FAMILY.groom.relation}
      />
      <FamilyInfo
        dad={BRIDE_FAMILY.father.name}
        mom={BRIDE_FAMILY.mother.name}
        child={BRIDE_FAMILY.bride.name}
        relation={BRIDE_FAMILY.bride.relation}
      />
      <button className='invitation__btn-contact' onClick={openModal}>연락하기</button>
      {isModalOpen && (
        <ContactModal closeModal={closeModal}/>
      )}
    </div>
  );
}

export default Invitation;
